import * as React from "react";
const SvgRemove = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M200-440v-80h560v80H200Z" }));
export default SvgRemove;
